import React from 'react'
import PropTypes from 'prop-types'
import { PoweredByToast } from '../PoweredByToast/PoweredByToast'

import './EmptyCart.css'
import CartIcon from '../CartIcon/CartIcon'

const EmptyCart = ({ orderingAvailable }) => {
  return (
    <div styleName='emptyCartWrapper'>
      <div styleName='emptyCart'>
        <div styleName='cartCircle'>
          <CartIcon variant='light' />
        </div>
        {orderingAvailable ? (
          <p>
            Ready to go! <br />
            Add items to get started
          </p>
        ) : (
          <p>Items cannot be added to cart</p>
        )}
      </div>
      <PoweredByToast styleName='poweredBy' />
    </div>
  )
}

EmptyCart.propTypes = {
  orderingAvailable: PropTypes.bool
}

export default React.memo(EmptyCart)
